export const SET_GLOBAL_QUERY_FILTER_KEYS = 'SET_GLOBAL_QUERY_FILTER_KEYS';

export const setGlobalQueryFilterKeys = filterKeys => ({
  type: SET_GLOBAL_QUERY_FILTER_KEYS,
  data: filterKeys,
});
